import type { Substitution } from "../../../../../../types/substitutions.types";
import type { Card } from "../../../../../../types/cards.types";
import type { TeamLineup } from "../../../../../../types/teams.types";

import PlayerDisplay from "../player/player";

import * as CSS from "./team-list.styles";

const POSITION_LABELS: Record<string, string> = {
	G: "GK",
	D: "DEF",
	M: "MID",
	F: "FWD",
};

const CardPip = ({ type }: { type: "yellow" | "red" }) => (
	<span
		style={{
			display: "inline-block",
			width: 8,
			height: 12,
			background: type === "yellow" ? "#f5c518" : "#e00",
			borderRadius: 1,
			marginLeft: 3,
			verticalAlign: "middle",
		}}
	/>
);

export interface TeamListProps {
	team: TeamLineup;
	subs: Substitution[];
	cards: Card[];
	scorers: Map<number, number>;
}

const TeamList = ({ team, subs, cards, scorers }: TeamListProps) => {
	const allPairs = subs.flatMap((s) => s.subs);
	const subMap = new Map(allPairs.map((p) => [p.playerOut, p]));
	const cardsByPlayer = cards.reduce<Record<string, Card[]>>((acc, c) => {
		if (!acc[c.player]) {
			acc[c.player] = [];
		}
		acc[c.player].push(c);
		return acc;
	}, {});

	return (
		<CSS.TeamList>
			{/* <PlayerDisplay
				player={{
					grid: null,
					number: 999,
					name: team.coach,
					position: "C",
					id: 999,
				}}
				playerCards={cardsByPlayer[team.coach] ?? []}
			/> */}
			{team.startXI.map((p, index) => (
				<PlayerDisplay
					key={p.id}
					player={p}
					sub={subMap.get(p.name)}
					playerCards={cardsByPlayer[p.name] ?? []}
					goals={scorers.get(p.id)}
					showBottomBorder={index < team.startXI.length - 1}
				/>
			))}
		</CSS.TeamList>
	);
};

export default TeamList;
